import React, { useEffect, useState } from "react";
import http from "../../../Utils/axiosConfig";
import { toISODate } from "../../../Utils/commonFuntion";
import { apiMessage } from "../../../Utils/apiMessage";
import ToastService from "../../../Utils/ToastService";
import "./Details.css";

const PAGE_SIZE = 10;

const AnimalFood = ({ mem_id }) => {
  const [supplyData, setSupplyData] = useState({
    records: [],
    balance: 0,
    total: 0,
  });
  const [formData, setFormData] = useState({
    date: toISODate(),
    type: "सुग्रास",
    bags: 1,
    rate: 1060,
    total_rate: 1060,
    debit: "",
  });
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  const rateMapping = {
    सुग्रास: 1060,
    "टि.एम.आर": 200,
    "फर्टिमन प्लस": 130,
    फर्टिमन: 80,
    "भेट शुल्क": 60,
    इतर: 0,
  };

  const refreshTableData = async (pageNum = 1) => {
    try {
      const response = await http.post("account/get_supply", {
        mem_id,
        page: pageNum,
        limit: PAGE_SIZE,
      });
      if (response.code === "DATA_FOUND") {
        setSupplyData(response.data || { records: [], balance: 0, total: 0 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    refreshTableData(page);
  }, [page]);

  const isCutting = formData.type === "कपात";

  const handleInputChange = (field, value) => {
    setFormData((prev) => {
      const updated = { ...prev, [field]: value };
      if (field === "type") {
        if (value === "कपात") {
          updated.bags = "";
          updated.rate = "";
          updated.total_rate = "";
        } else {
          updated.rate = rateMapping[value] ?? 0;
          updated.total_rate = updated.rate * updated.bags;
        }
      } else if (field === "bags") {
        updated.total_rate = updated.rate * parseInt(value || 0);
      } else if (field === "rate") {
        updated.total_rate = parseFloat(value || 0) * parseInt(updated.bags || 0);
      }
      return updated;
    });
  };

  const isFormValid = () =>
    isCutting
      ? formData.date && Number(formData.debit) > 0
      : formData.date && formData.type && formData.bags > 0 && formData.rate > 0;

  const handleSubmit = async () => {
    if (!isFormValid()) {
      ToastService.warning("कृपया सर्व फील्ड भरा");
      return;
    }
    setLoading(true);
    try {
      const body = isCutting
        ? {
            mem_id,
            date: formData.date,
            type: "कपात",
            debit: parseFloat(formData.debit),
          }
        : {
            mem_id,
            date: formData.date,
            type: formData.type,
            bags: parseInt(formData.bags),
            rate: parseFloat(formData.rate),
            total_rate: parseFloat(formData.total_rate),
          };
      const response = await http.post("account/post_supply", body);
      if (response.code === "DETAILS_POSTED") {
        ToastService.success(apiMessage(response, "माहिती जतन झाली ✅"));
        setFormData({
          date: toISODate(),
          type: "सुग्रास",
          bags: 1,
          rate: 1060,
          total_rate: 1060,
          debit: "",
        });
        setPage(1);
        await refreshTableData(1);
      }
    } catch (error) {
      console.error("Error saving:", error);
      ToastService.error(apiMessage());
    } finally {
      setLoading(false);
    }
  };

  const onlyNumber = (e, isDec = true) => {
    const blockedKeys = ["e", "E", "+", "-"];
    if (!isDec) blockedKeys.push(".");
    if (blockedKeys.includes(e.key)) e.preventDefault();
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const totalPages = Math.ceil((supplyData.total || 0) / PAGE_SIZE);

  return (
    <div className="animal-food-container">
      <div className="animal-food-form-section">
        <div className="form-field-group">
          <label className="dre-field-label">तारीख</label>
          <input
            type="date"
            className="dre-input"
            value={formData.date}
            onChange={(e) => handleInputChange("date", e.target.value)}
          />
        </div>

        <div className="form-field-group">
          <label className="dre-field-label">प्रकार</label>
          <select
            className="dre-input"
            value={formData.type}
            onChange={(e) => handleInputChange("type", e.target.value)}
          >
            <option value="सुग्रास">सुग्रास</option>
            <option value="टि.एम.आर">टि.एम.आर</option>
            <option value="फर्टिमन प्लस">फर्टिमन प्लस</option>
            <option value="फर्टिमन">फर्टिमन</option>
            <option value="भेट शुल्क">भेट शुल्क</option>
            <option value="इतर">इतर</option>
            <option value="कपात">कपात</option>
          </select>
        </div>

        {isCutting ? (
          <div className="form-field-group">
            <label className="dre-field-label">रक्कम</label>
            <input
              type="number"
              className="dre-input"
              min="0"
              value={formData.debit}
              onChange={(e) => handleInputChange("debit", e.target.value)}
              onKeyDown={(e) => onlyNumber(e, true)}
            />
          </div>
        ) : (
          <>
            <div className="form-field-group">
              <label className="dre-field-label">पिशवी</label>
              <input
                type="number"
                className="dre-input"
                min="1"
                step="1"
                value={formData.bags}
                onChange={(e) => handleInputChange("bags", e.target.value)}
                onKeyDown={(e) => onlyNumber(e, false)}
              />
            </div>

            <div className="form-field-group">
              <label className="dre-field-label">दर</label>
              <input
                type="number"
                className="dre-input"
                min="0"
                value={formData.rate}
                onChange={(e) => handleInputChange("rate", e.target.value)}
                onKeyDown={(e) => onlyNumber(e, true)}
              />
            </div>

            <div className="form-field-group">
              <label className="dre-field-label">एकूण दर</label>
              <input
                type="number"
                className="dre-input readonly-input"
                value={formData.total_rate}
                readOnly
              />
            </div>
          </>
        )}

        <button
          className="dre-submit-btn"
          onClick={handleSubmit}
          disabled={!isFormValid() || loading}
        >
          {loading ? "सेव्ह..." : "OKAY"}
        </button>
      </div>

      <div className="balance-bar">
        <span>एकूण शिल्लक:</span>
        <span className="balance-amount">Rs. {supplyData?.balance ?? 0}</span>
      </div>

      <div className="table-container">
        {supplyData?.records?.length > 0 ? (
          <>
            <div className="table-wrapper">
              <table className="emc-table">
                <thead>
                  <tr>
                    <th>तारीख</th>
                    <th>प्रकार</th>
                    <th>पिशवी</th>
                    <th>दर</th>
                    <th>रक्कम</th>
                    <th>कपात</th>
                  </tr>
                </thead>
                <tbody>
                  {supplyData.records.map((record, index) => (
                    <tr key={index}>
                      <td>{formatDate(record.date)}</td>
                      <td>{record.type || "-"}</td>
                      <td>{record.bags || "-"}</td>
                      <td>{record.rate || "-"}</td>
                      <td>{record.total_rate || "-"}</td>
                      <td>{record.debit || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {totalPages > 1 && (
              <div className="pagination">
                <button
                  className="page-btn"
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                  disabled={page === 1}
                >
                  &#8249;
                </button>
                <span className="page-info">
                  {page} / {totalPages}
                </span>
                <button
                  className="page-btn"
                  onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                  disabled={page === totalPages}
                >
                  &#8250;
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="no-data">
            <p>कोणतेही रेकॉर्ड आढळले नाही.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AnimalFood;
